import { useEffect, useState } from "react";

/**
 * True when the viewport is narrower than `breakpoint` px (default 768 = below
 * Tailwind `md`). Used to switch tables to card lists on phones. SSR-safe:
 * starts false, corrects on mount.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [breakpoint]);
  return isMobile;
}
